import { store } from "@/store/store";
import { estados_cita } from "@/shared/dtos/estados_cita";
import { VuexModule, Mutation, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({ namespaced: true, name: "estadosCitaModule", store, dynamic: true })
class estadosCitaModule extends VuexModule {
  public rows: estados_cita[] = [];
  public row: estados_cita = new estados_cita();

  @Action({ commit: "onGetRows" })
  public async getRows() {
    return await ssmHttpService.get(API.estados_cita);
  }

  @Action({ commit: "onGetRow" })
  public async getRow(id: any) {
    return await ssmHttpService.get(API.estados_cita + "/" + id);
  }

  @Action
  public async guardar(item: estados_cita) {
    return await ssmHttpService.post(API.estados_cita, item.toJson());
  }

  @Action
  public async modificar(item: estados_cita) {
    return await ssmHttpService.put(API.estados_cita + "/" + item.id, item.toJson());
  }

  @Action
  public async eliminar(item: estados_cita) {
    return await ssmHttpService.delete(API.estados_cita + "/" + item.id, null, false);
  }

  @Mutation
  public onGetRows(res: estados_cita[]) {
    this.rows = res ? res.map((x) => new estados_cita(x)) : [];
  }

  @Mutation
  public onGetRow(res: estados_cita) {
    this.row = new estados_cita(res);
  }
}

export default getModule(estadosCitaModule);
